import React from "react";
import internet from "../../images/undraw_connected_world_wuay.svg"
import "./internet.css";
const Internet = () => {
  return (
    <div className="internet">
      <h2>تأكد من اتصالك بالانترنت </h2>

      <img src={internet} alt="internet" />
    </div>
  );
};

export default Internet;      
